import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Grid, Button, Stack } from '@mui/material';

import { tabsData } from './utils/tabsData';
import { SET_SELECTED_ITEM } from 'store/actions';
import { transactionStyles } from './styles/styles';
import { useCustomMediaQuery } from 'hooks/useMediaQuery';
import UploadTransactions from './components/UploadTransactions';
import ImportBankTransaction from './components/ImportBankTransaction';

export const Transaction = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedTab = useSelector((state) => state.me.selectedItems);
    const classes = transactionStyles({ isMobileScreen: useCustomMediaQuery('(max-width:600px)') });

    const changeTab = (tab) => {
        dispatch(SET_SELECTED_ITEM(tab.label));
        navigate(`/transactions${tab.path}`);
    };

    useEffect(() => {
        const currentPath = location.pathname.replace('/transactions', '');
        const currentTab = tabsData.find((tab) => currentPath.startsWith(tab.path));
        if (currentTab && currentTab.label !== selectedTab) {
            dispatch(SET_SELECTED_ITEM(currentTab.label));
        } else if (!currentTab && tabsData.length > 0) {
            dispatch(SET_SELECTED_ITEM(tabsData[0].label));
            navigate(`/transactions${tabsData[0].path}`);
        }
    }, [location.pathname, dispatch, selectedTab, tabsData, navigate]);

    const getTabButtonStyle = (tabLabel) => ({
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: selectedTab === tabLabel ? '600' : '500',
        backgroundColor: selectedTab === tabLabel ? '#CEEFDF' : 'transparent',
        borderRadius: selectedTab === tabLabel ? '3px' : 'none',
        color: selectedTab === tabLabel ? '#0A8C4D' : '#6C727F',
    });

    return (
        <Grid container>
            <Grid padding={1} sx={classes.tabsListContainer}>
                <Stack
                    gap={1}
                    display="flex"
                    alignItems="center"
                    sx={classes.stackStyles}
                    width={{ xs: '100%', md: 'fit-content' }}
                    flexDirection={{ xs: 'column', md: 'row' }}
                >
                    {tabsData.map((tab) => (
                        <Grid
                            item
                            key={tab.label}
                            style={{
                                borderRadius: '5px',
                            }}
                        >
                            <Button
                                onClick={() => changeTab(tab)}
                                style={getTabButtonStyle(tab.label)}
                                variant={selectedTab === tab.label ? 'contained' : 'text'}
                            >
                                {tab.label}
                            </Button>
                        </Grid>
                    ))}
                </Stack>
            </Grid>

            {selectedTab === 'Upload Transactions' && (
                <Grid item xs={12} sx={classes.tabsContainer}>
                    <UploadTransactions />
                </Grid>
            )}

            {selectedTab === 'Import bank transactions' && (
                <Grid item xs={12} mt={2} container sx={classes.tabsContainer}>
                    <ImportBankTransaction />
                </Grid>
            )}
        </Grid>
    );
};
